<template>
    <div class="head-secondary">
        <span>The DC x Grind South Side Summer Skate Clinic is a youth-driven skateboarding program organized in collaboration with Filinvest City and in partnership with Malachi Skateboarding.</span>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>

<style lang="scss">
.head-secondary {
    background: #20beca;
    color: $white;
    width: 100%;
    padding: 8px 24px;
    font-size: 0.8em;
}
@media(min-width: 672px){
    .head-secondary {
        padding-inline: 7% !important;
    }
}
</style>